webpackJsonp([2],Array(26).concat([
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Editor__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Editor__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Editor',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Editor___default.a
  }]
}));

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(76)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(96),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(26);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AreaSelect__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AreaSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AreaSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PDF__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PDF___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PDF__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SelectionPreview__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SelectionPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SelectionPreview__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Annotator',
  components: {
    AreaSelect: __WEBPACK_IMPORTED_MODULE_0__components_AreaSelect___default.a,
    PDF: __WEBPACK_IMPORTED_MODULE_1__components_PDF___default.a,
    SelectionPreview: __WEBPACK_IMPORTED_MODULE_2__components_SelectionPreview___default.a
  },
  props: ['src', 'name', 'selections', 'addSelection', 'arrayBuffer', 'setPdfSize'],
  data: function data() {
    return {
      down: false,
      coords: {
        xa: null,
        ya: null,
        xb: null,
        yb: null
      },
      pageNumber: 1,
      pageOffset: {
        top: 0,
        left: 0
      }
    };
  },

  computed: {
    coordinates: function coordinates() {
      return {
        left: Math.min(this.coords.xa, this.coords.xb),
        top: Math.min(this.coords.ya, this.coords.yb),
        width: Math.abs(this.coords.xa - this.coords.xb),
        height: Math.abs(this.coords.ya - this.coords.yb),
        page: this.pageNumber,
        pageOffset: {
          top: this.pageOffset.top,
          left: this.pageOffset.left
        }
      };
    }
  },
  methods: {
    reset: function reset() {
      this.coords.xa = null;
      this.coords.ya = null;
      this.coords.xb = null;
      this.coords.yb = null;
    },
    start: function start(event) {
      // event.stopPropagation()
      // event.preventDefault()
      this.down = true;

      this.pageNumber = parseInt(event.target.getAttribute('data-page-number') || 1);
      this.pageOffset.top = event.target.offsetTop;
      this.pageOffset.left = event.target.offsetLeft;
      this.coords.xa = event.offsetX;
      this.coords.ya = event.offsetY;
      this.coords.xb = event.offsetX;
      this.coords.yb = event.offsetY;
    },
    end: function end(event) {
      event.stopPropagation();
      event.preventDefault();
      this.down = false;
      this.addSelection(this.coordinates);
      this.reset();
    },
    drag: function drag(event) {
      event.stopPropagation();
      event.preventDefault();
      if (this.down) {
        this.coords.xb = event.offsetX;
        this.coords.yb = event.offsetY;
      }
    }
  }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'area-select',
  props: ['coordinates', 'color', 'name', 'active'],
  computed: {
    styleObject: function styleObject() {
      if (this.height === 0 || this.width === 0) {
        return {
          display: 'none'
        };
      }
      return {
        left: this.coordinates.left + this.coordinates.pageOffset.left + 'px',
        top: this.coordinates.top + this.coordinates.pageOffset.top + 'px',
        width: this.coordinates.width + 'px',
        height: this.coordinates.height + 'px',
        border: 'solid ' + this.color + ' 1px',
        background: this.color.replace(/\)$/, ', 0.05)').replace('rgb(', 'rgba(')
      };
    }
  }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Uploader__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Uploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Annotator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Annotator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Annotator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ZoneViewer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ZoneViewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ZoneViewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PDFZoneViewer__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PDFZoneViewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PDFZoneViewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_randomcolor__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_randomcolor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_randomcolor__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'editor',
  components: {
    Uploader: __WEBPACK_IMPORTED_MODULE_0__components_Uploader___default.a,
    Annotator: __WEBPACK_IMPORTED_MODULE_1__components_Annotator___default.a,
    ZoneViewer: __WEBPACK_IMPORTED_MODULE_2__components_ZoneViewer___default.a,
    PDFZoneViewer: __WEBPACK_IMPORTED_MODULE_3__components_PDFZoneViewer___default.a
  },
  data: function data() {
    return {
      src: null,
      arrayBuffer: null,
      name: '',
      selections: [],
      pdfDimensions: {
        height: 0,
        width: 0
      }
    };
  },

  methods: {
    batchUpdateSelections: function batchUpdateSelections(selections) {
      this.selections = selections;
    },
    setPdfSize: function setPdfSize(width, height) {
      this.pdfDimensions = {
        width: width,
        height: height
      };
    },
    addSelection: function addSelection(coords) {
      if (coords.height === 0 || coords.width === 0) {
        return;
      }

      this.selections.push({
        id: +new Date(),
        coordinates: {
          top: coords.top,
          left: coords.left,
          height: coords.height,
          width: coords.width,
          page: coords.page,
          pageOffset: coords.pageOffset
        },
        color: __WEBPACK_IMPORTED_MODULE_4_randomcolor___default()({ format: 'rgb' }),
        name: 'Unnamed' + this.selections.length
      });
    },
    newFile: function newFile(data) {
      this.name = data.name;
      this.src = data.src;
      this.arrayBuffer = data.arrayBuffer;
      this.selections = [];
    }
  }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pdfjs_dist_web_pdf_viewer_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pdfjs_dist_web_pdf_viewer_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pdfjs_dist_web_pdf_viewer_js__);
//
//
//
//
//
//
//
//

var PDFJS = __webpack_require__(79);


PDFJS.PDFViewer = __WEBPACK_IMPORTED_MODULE_0__node_modules_pdfjs_dist_web_pdf_viewer_js___default.a.PDFJS.PDFViewer;

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['arrayBuffer', 'setPdfSize'],
  data: function data() {
    return {
      width: null
    };
  },

  computed: {
    styleObject: function styleObject() {
      return {
        width: this.width ? this.width + 'px' : 'auto'
      };
    }
  },
  watch: {
    arrayBuffer: function arrayBuffer() {
      this.loadDocument();
    }
  },
  methods: {
    loadDocument: function loadDocument() {
      var _this = this;

      console.log('new document');
      PDFJS.getDocument(this.arrayBuffer).then(function (pdf) {
        pdf.getPage(1).then(function (page) {
          var viewport = page.getViewport(1);
          _this.setPdfSize(viewport.width, viewport.height);
          _this.width = viewport.width;
          _this.pdfViewer.setDocument(pdf).then(function () {
            window.scrollTo(0, 0);
          });
        });
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var container = this.$refs['pdf-container'];

    this.pdfViewer = new PDFJS.PDFViewer({
      container: container
    });

    container.addEventListener('pagesinit', function () {
      _this2.pdfViewer.currentScaleValue = 'page-width';
    });
    this.loadDocument();
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['selections', 'batchUpdateSelections', 'originalFilename', 'dimensions'],
  data: function data() {
    return {
      uzn: null,
      editing: false
    };
  },

  computed: {
    downloadable: function downloadable() {
      var blob = new Blob([this.uzn], { type: 'octet/stream' });
      var url = window.URL.createObjectURL(blob);
      return url;
    },
    filename: function filename() {
      return this.originalFilename.replace(/(.*)\..*/, '$1.uzn');
    }
  },
  mounted: function mounted() {
    this.redrawUzn();
  },

  watch: {
    selections: function selections() {
      this.redrawUzn();
    }
  },
  methods: {
    startEditing: function startEditing() {
      this.editing = true;
    },
    stopEditing: function stopEditing() {
      this.editing = false;
      this.redrawUzn();
    },
    redrawUzn: function redrawUzn() {
      var _this = this;

      if (this.editing) {
        return;
      }
      if (this.selections.length === 0) {
        this.uzn = '';
        return;
      }
      var lines = this.selections.map(function (s) {
        var y0 = parseInt(_this.dimensions.height - s.coordinates.top);
        var y1 = parseInt(_this.dimensions.height - s.coordinates.top - s.coordinates.height);
        var bbox = [s.coordinates.left, Math.max(y0, y1), s.coordinates.left + s.coordinates.width, Math.min(y0, y1)].join(',');
        var query = 'LTPage[pageid=\\\'' + s.coordinates.page + '\\\'] LTTextLineHorizontal:overlaps_bbox("' + bbox + '")';
        return '\t(\'' + s.name + '\', \'' + query + '\')';
      });

      var pretty = lines.join(',\n');
      this.uzn = 'pdf = pdfquery.PDFQuery(\'' + this.originalFilename + '\')\n\npdf.extract([\n\t(\'with_formatter\', \'text\'),\n' + pretty + '\n])';
    },
    changed: function changed(event) {
      var _this2 = this;

      console.log('CHANGED');
      var index = 0;
      var selections = this.uzn.split('\n').map(function (line) {
        var elements = line.match(/\('(.*)',.*pageid=\\'(\d+)\\'.*bbox\("(\d+),(\d+),(\d+),(\d+)"\)/);
        try {
          // 1 - name
          // 2 - page
          // 3 - left
          // 4 - top
          // 5 - right
          // 6 - bottom (?)
          var selection = _this2.selections[index];
          selection.coordinates.left = parseInt(elements[3]);
          selection.coordinates.top = _this2.dimensions.height - parseInt(elements[4]);
          selection.coordinates.width = parseInt(elements[5]) - parseInt(elements[3]);
          selection.coordinates.height = Math.abs(parseInt(elements[6]) - parseInt(elements[4]));
          selection.name = elements[1];
          selection.page = elements[2];
          index++;
          return selection;
        } catch (err) {
          console.log(err);
          return null;
        }
      }).filter(function (selection) {
        return selection != null;
      });

      this.batchUpdateSelections(selections);
    }
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['coordinates'],
  data: function data() {
    return {
      text: null
    };
  },

  computed: {},
  watch: {
    coordinates: function coordinates() {
      this.highlightOverlaps();
      // this.text = this.overlappingText()
    }
  },
  methods: {
    hasCoordinates: function hasCoordinates() {
      var coordinates = this.coordinates;
      if (!coordinates || !coordinates.top || !coordinates.left || coordinates.height === 0 || coordinates.width === 0) {
        return false;
      }
      return true;
    },
    overlapping: function overlapping() {
      if (this.hasCoordinates()) {
        var allText = document.querySelectorAll('.page[data-page-number="1"] .textLayer div');
        return Array.prototype.filter.call(allText, this._overlaps);
      } else {
        return [];
      }
    },
    overlappingText: function overlappingText() {
      return this.overlapping().map(function (element) {
        return element.textContent;
      }).join(' ');
    },
    highlightOverlaps: function highlightOverlaps() {
      this.unhighlight();
      this.overlapping().forEach(this._highlight);
    },
    _highlight: function _highlight(element) {
      if (element.className.indexOf('selected-preview') === -1) {
        element.className += ' selected-preview';
      }
    },
    unhighlight: function unhighlight(element) {
      var highlighted = document.querySelectorAll('.selected-preview');
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(highlighted), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var h = _step.value;

          h;
          h.className = h.className.replace('selected-preview', '');
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    _overlaps: function _overlaps(element) {
      var coordinates = this.coordinates;
      if (element.offsetLeft > coordinates.left + coordinates.width || element.offsetLeft + element.offsetWidth < coordinates.left) {
        return false;
      }
      if (element.offsetTop > coordinates.top + coordinates.height || coordinates.top > element.offsetTop + element.offsetHeight) {
        return false;
      }
      return true;
    },
    _sorted: function _sorted(a, b) {
      if (a.offsetTop === b.offsetTop) {
        return a.offsetLeft < b.offsetTop ? -1 : 1;
      }
      return a.offsetTop < b.offsetTop ? -1 : 1;
    }
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    notify: {
      type: Function,
      require: true
    }
  },
  data: function data() {
    return {
      name: null
    };
  },

  methods: {
    processReaderImage: function processReaderImage(readerData) {
      this.notify({
        name: this.name,
        src: readerData.target.result
      });
    },
    processReaderPDF: function processReaderPDF(readerData) {
      this.notify({
        name: this.name,
        arrayBuffer: readerData.target.result
      });
    },
    getFile: function getFile(fileList) {
      var file = fileList[0];

      this.name = file.name;

      if (file.type.match('image.*')) {
        var reader = new FileReader();
        reader.addEventListener('load', this.processReaderImage, false);
        reader.readAsDataURL(file);
      } else if (file.type.match('.*pdf.*')) {
        var _reader = new FileReader();
        _reader.addEventListener('load', this.processReaderPDF, false);
        _reader.readAsArrayBuffer(file);
      } else {
        alert('Not a PDF or image file');
      }
    },
    selected: function selected(event) {
      this.getFile(event.target.files);
    },
    drop: function drop(event) {
      event.stopPropagation();
      event.preventDefault();
      this.getFile(event.dataTransfer.files);
    },
    dragover: function dragover(event) {
      event.stopPropagation();
      event.preventDefault();
      event.dataTransfer.dropEffect = 'copy';
    }
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'zone-viewer',
  props: ['selections', 'batchUpdateSelections', 'originalFilename'],
  data: function data() {
    return {
      uzn: null,
      editing: false
    };
  },

  computed: {
    downloadable: function downloadable() {
      var blob = new Blob([this.uzn], { type: 'octet/stream' });
      var url = window.URL.createObjectURL(blob);
      return url;
    },
    filename: function filename() {
      return this.originalFilename.replace(/(.*)\..*/, '$1.uzn');
    }
  },
  mounted: function mounted() {
    this.redrawUzn();
  },

  watch: {
    selections: function selections() {
      this.redrawUzn();
    }
  },
  methods: {
    startEditing: function startEditing() {
      this.editing = true;
    },
    stopEditing: function stopEditing() {
      this.editing = false;
      this.redrawUzn();
    },
    redrawUzn: function redrawUzn() {
      if (this.editing) {
        return;
      }
      var lines = this.selections.map(function (s) {
        return s.coordinates.left + ' ' + s.coordinates.top + ' ' + s.coordinates.width + ' ' + s.coordinates.height + ' ' + s.name;
      });

      this.uzn = lines.join('\n');
    },
    changed: function changed(event) {
      var _this = this;

      var selections = this.uzn.split('\n').map(function (line, index) {
        try {
          var elements = line.match(/(\d+) (\d+) (\d+) (\d+) (.*)/);
          var selection = _this.selections[index];
          selection.coordinates.left = parseInt(elements[1]);
          selection.coordinates.top = parseInt(elements[2]);
          selection.coordinates.width = parseInt(elements[3]);
          selection.coordinates.height = parseInt(elements[4]);
          selection.name = elements[5];
          return selection;
        } catch (err) {
          return null;
        }
      }).filter(function (selection) {
        return selection != null;
      });
      console.log('updating with', selections);
      this.batchUpdateSelections(selections);
    }
  }
});

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(75)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(95),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-557e482b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(72)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(92),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1849b72a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(77)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(97),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(70)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(90),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(74)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(94),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b727782",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(73)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(93),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(69)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(89),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0043a522",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(71)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(91),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "dragover"
    },
    on: {
      "dragover": _vm.dragover,
      "drop": _vm.drop
    }
  }, [_c('h3', [_vm._v("Drag & drop your file here")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("accepts images and PDFs")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "file",
      "name": "file"
    },
    on: {
      "change": _vm.selected
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("or "), _c('label', {
    attrs: {
      "for": "file"
    }
  }, [_vm._v("click to browse")])])
}]}

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "pdf-container",
    staticClass: "pdf-container",
    style: (_vm.styleObject)
  }, [_c('div', {
    staticClass: "pdfViewer"
  })])])
},staticRenderFns: []}

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selections.length > 0) ? _c('div', {
    staticClass: "zone-viewer"
  }, [_c('h2', [_vm._v("Your zone file")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uzn),
      expression: "uzn"
    }],
    ref: "textarea",
    domProps: {
      "value": (_vm.uzn)
    },
    on: {
      "keyup": _vm.changed,
      "blur": _vm.stopEditing,
      "focus": _vm.startEditing,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.uzn = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.downloadable,
      "download": _vm.filename
    }
  }, [_vm._v("Download .uzn file")])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Edit the code below")]), _vm._v(" and it'll update on the right!")])
}]}

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selection-box",
    style: (_vm.styleObject)
  }, [_c('span', [_vm._v(_vm._s(_vm.name))])])
},staticRenderFns: []}

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview"
  }, [_vm._v("\n" + _vm._s(_vm.text) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selections.length > 0) ? _c('div', {
    staticClass: "pdf-zone-viewer"
  }, [_c('h2', [_vm._v("Your extraction code")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uzn),
      expression: "uzn"
    }],
    ref: "textarea",
    domProps: {
      "value": (_vm.uzn)
    },
    on: {
      "keyup": _vm.changed,
      "blur": _vm.stopEditing,
      "focus": _vm.startEditing,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.uzn = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Edit the variable names and numbers below")]), _vm._v(" and you'll see it update to the right!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("This code uses "), _c('a', {
    attrs: {
      "href": "https://github.com/jcushman/pdfquery",
      "target": "_blank"
    }
  }, [_vm._v("pdfquery")]), _vm._v(". You can just cut and paste if you want, but if you read the documentation it'll save you a lot of time.")])
}]}

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.name) ? _c('h3', [_vm._v("\n    Currently working on: "), _c('span', {
    staticClass: "filename"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', {
    staticClass: "filetype"
  }, [_vm._v(_vm._s(_vm.arrayBuffer ? "PDF" : "image"))])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("If you want to zoom in/out, you'll need to use your browser zoom for the moment.")]), _vm._v(" "), (_vm.src || _vm.arrayBuffer) ? _c('div', {
    ref: "selectionArea",
    staticClass: "selection-area",
    on: {
      "mousedown": _vm.start,
      "mouseup": _vm.end,
      "mousemove": _vm.drag
    }
  }, [(_vm.src) ? _c('img', {
    attrs: {
      "src": _vm.src
    }
  }) : _vm._e(), _vm._v(" "), (_vm.arrayBuffer) ? _c('PDF', {
    attrs: {
      "setPdfSize": _vm.setPdfSize,
      "arrayBuffer": _vm.arrayBuffer
    }
  }) : _vm._e(), _vm._v(" "), (_vm.arrayBuffer) ? _c('SelectionPreview', {
    attrs: {
      "coordinates": _vm.coordinates
    }
  }) : _vm._e(), _vm._v(" "), _c('AreaSelect', {
    ref: "activeSelector",
    attrs: {
      "coordinates": _vm.coordinates,
      "color": "rgb(0,255,0)",
      "active": "true"
    }
  }), _vm._v(" "), _vm._l((_vm.selections), function(selection) {
    return _c('AreaSelect', {
      key: selection.id,
      attrs: {
        "color": selection.color,
        "coordinates": selection.coordinates,
        "name": selection.name
      }
    })
  })], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editor"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('h1', [_vm._v("Kull")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('Uploader', {
    attrs: {
      "notify": _vm.newFile
    }
  }), _vm._v(" "), (_vm.name) ? _c('p', [_c('strong', [_vm._v("Click and drag on the image to the right")]), _vm._v(" to form selection areas.")]) : _vm._e(), _vm._v(" "), (_vm.src) ? _c('ZoneViewer', {
    staticClass: "zone-viewer",
    attrs: {
      "selections": _vm.selections,
      "batchUpdateSelections": _vm.batchUpdateSelections,
      "originalFilename": _vm.name
    }
  }) : _vm._e(), _vm._v(" "), (_vm.arrayBuffer) ? _c('PDFZoneViewer', {
    staticClass: "zone-viewer",
    attrs: {
      "dimensions": _vm.pdfDimensions,
      "selections": _vm.selections,
      "batchUpdateSelections": _vm.batchUpdateSelections,
      "originalFilename": _vm.name
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('Annotator', {
    attrs: {
      "src": _vm.src,
      "setPdfSize": _vm.setPdfSize,
      "arrayBuffer": _vm.arrayBuffer,
      "name": _vm.name,
      "selections": _vm.selections,
      "addSelection": _vm.addSelection
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("A tool to interactively select text regions of PDFs and images.")]), _vm._v(" Use with "), _c('a', {
    attrs: {
      "href": "https://github.com/jcushman/pdfquery"
    }
  }, [_vm._v("PDFQuery")]), _vm._v(" (Python/PDF) or to make UZN/OCR zone files for "), _c('a', {
    attrs: {
      "href": "https://github.com/tesseract-ocr/tesseract"
    }
  }, [_vm._v("tesseract")]), _vm._v(" (image-to-text).")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("More details (maybe) at "), _c('a', {
    attrs: {
      "href": "https://github.com/jsoma/kull"
    }
  }, [_vm._v("https://github.com/jsoma/kull")]), _vm._v(".")])
}]}

/***/ })
]),[29]);


// WEBPACK FOOTER //
// static/js/app.4df998011aada0dee28f.js